// Libs
import { lazy, ReactNode, Suspense } from 'react';
import { Navigate } from 'react-router';

// Hooks
import { useUserQuery } from '~fpu/shared/global-queries';
import { useFeatureFlag } from '~fpu/shared/hooks/useFeatureFlag';

// Utils
import { PATHS } from '~fpu/config/constants';
import {
  isOrganizationAdmin,
  isSupportTeam
} from '~fpu/shared/utils/user-class-authorities';

// Config
import { FEATURE_KEYS } from '~fpu/config/optimizely';

const HomeDashboard = lazy(() => import('./HomeDashboard'));

function HomeDashboardGate({
  legacy,
  requiresAdmin = false
}: {
  legacy: ReactNode;
  requiresAdmin?: boolean;
}) {
  const { data: user } = useUserQuery();
  const { isEnabled, isLoading } = useFeatureFlag(
    FEATURE_KEYS.FPU_UNIFIED_DASHBOARD_HOME
  );

  if (isLoading) return null;

  if (!isEnabled) return legacy;

  if (requiresAdmin && !isOrganizationAdmin(user) && !isSupportTeam(user)) {
    return <Navigate to={PATHS.FPU_DASHBOARD.COORDINATOR} replace />;
  }

  return (
    <Suspense fallback={null}>
      <HomeDashboard />
    </Suspense>
  );
}

export default HomeDashboardGate;
